export var EksClusterStatus;
(function (EksClusterStatus) {
    EksClusterStatus["EKS_CLUSTER_STATUS_UNSPECIFIED"] = "EKS_CLUSTER_STATUS_UNSPECIFIED";
    EksClusterStatus["EKS_CLUSTER_STATUS_CREATING"] = "EKS_CLUSTER_STATUS_CREATING";
    EksClusterStatus["EKS_CLUSTER_STATUS_ACTIVE"] = "EKS_CLUSTER_STATUS_ACTIVE";
    EksClusterStatus["EKS_CLUSTER_STATUS_DELETING"] = "EKS_CLUSTER_STATUS_DELETING";
    EksClusterStatus["EKS_CLUSTER_STATUS_FAILED"] = "EKS_CLUSTER_STATUS_FAILED";
    EksClusterStatus["EKS_CLUSTER_STATUS_UPDATING"] = "EKS_CLUSTER_STATUS_UPDATING";
    EksClusterStatus["EKS_CLUSTER_STATUS_PENDING"] = "EKS_CLUSTER_STATUS_PENDING";
})(EksClusterStatus || (EksClusterStatus = {}));
